// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__GbyvJ","content":"LoadingAlert_content__16KdW"};